import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/Services/api.service';
import { DialogActionService } from 'src/app/Services/dialog-actions.service';
import { SharedService } from 'src/app/Services/shared.service';
import { StorageService } from 'src/app/Services/storage.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';
declare const popup: any, snackbar: any;


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  username = '';
  password = '';
  confirm_password = '';
  showSpinner: boolean;
  inputType = 'password';
  adPswdSt: boolean;
  adEmail: string;
  isShowContent: any;
  isShowEyes = true;
  
  forgotName: string;
  isForget: any;
  isShowForgotError = false;
  noFields: boolean = false;
  public fieldSubmitted:boolean = false;
  public enableInvalidUser:boolean = false;

  constructor(
    private router: Router,
    public storage: StorageService,
    public api: ApiService,
    public shared: SharedService,
    public dialogService: DialogActionService,
    public swal:SweetAlert
  ) {

  }
  ngOnInit(): void {
    // this.getAdminCheckData();
    this.shared._subject.next({
      isShowNavbar: false
    }
    );
  }

  login(): void {

    const isValidEmail = this.username.match('[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$');
    console.log(isValidEmail, this.username);
    if (isValidEmail && this.password) {

      // snackbar(`<span class="text-warning"> Login success </span>`)
      this.api.vendorLogin({ email: this.username, password: this.password })
        .then((res: any) => {

          if (res.status == 'success') {
            this.shared._subject.next({
              isShowNavbar: true
            });
            this.storage.setData({ userType: 'vendor', token: res.token });
            this.router.navigate(['/organization/vendor/dashboard']);
            // this.openLogoutModal(res)

          } else {
            this.swal.swalFunction('error', res.status, res.message, 2000);
            // snackbar(`<span class="text-warning"> ${res.message} </span>`)
            // this.openLogoutModal(res);
          }
        })


        .catch((err) => console.log(err));
    } else if (this.password) {
      if (isValidEmail == null && this.username != '') {
        snackbar(`<span class="text-warning"> Invalid username</span>`);
      } else if (isValidEmail == null && this.username == '') {
        snackbar(`<span class="text-warning"> username required</span>`);
      }
    } else if (this.username != '' && isValidEmail != null) {

      snackbar(`<span class="text-warning"> Password required </span>`);
    } else {
      snackbar(`<span class="text-warning"> Username and password required </span>`);
    }
  }
  openLogoutModal(value) {
    const userId = 'user01';
    const config = {
      name: value.message,
      title: value.status,
      description: value.message,
      actionButtonText: '',
      userId
    };
    this.dialogService.popup(config);
    // const modalDialog = this.dialog.open(DialogComponent, dialogConfig);
  }
  keychange(event) {
    if (event.keyCode == 32) {
      this.username = '';
      // alert('press space')
    }
  }
  viewPassword() {
    this.isShowEyes = !this.isShowEyes;
    this.inputType = this.inputType == 'text' ? 'password' : 'text';
  }

  getAdminCheckData() {

    this.api.getMasterLoginData({})
      .then((res: any) => {
        if (res.status) {
          this.adPswdSt = res.adminPasswordSet;
          this.adEmail = res.email;
          if (res.adminPasswordSet) {
            this.storage.setData({ adEmail: res.email });
            this.router.navigate(['master/active-link']);
          }
        } else {
          alert(res.status);
        }
        console.log(res.adminPasswordSet, res.email, res.status);
      }).catch((err: any) => {
        console.log(err);
      });
  }
  

  // Ender button
  enterToLogin(e) {
    if (e.keyCode === 13) {
      this.login();
    }
  }

  forgotEmailValid() {
    this.noFields = false;
    this.enableInvalidUser = false;
    // this.forgotEmail.match('[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$')
    if (this.forgotName) {
      this.isForget = this.forgotName.match('[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$');
    }
    if(this.fieldSubmitted){
      if (this.isForget) {
        this.isShowForgotError = false;
      } else {
        this.isShowForgotError = true;
      }
    }
  }

  sentMail() {
    this.fieldSubmitted = true;
    this.forgotEmailValid();
    if (!this.forgotName) {
      this.noFields = true;
      return;
    } else {
      this.noFields = false;
      if (this.forgotName) {
        console.log(this.forgotName);
        this.isForget = this.forgotName.match('[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$');
        // this.close()
      } else {
        this.isShowForgotError = true;
      }
      if (this.isForget) {
        const obj = {
          email: this.forgotName
        };
        console.log(obj);
        this.api.vendorForgotPassword(obj).then((res: any) => {
          if (res.status == 'success') {
            this.swal.swalFunction(res.status, res.status, res.message, 2000);
          }
          if (res.status == 'failure') {
            console.log('failure', res.message);
            this.enableInvalidUser = true;
            // snackbar(`<span class="text-warning">Invalid Email</span>`);
          }
        }).catch((err) => {
          console.log(err);
        });
      } else { return; }
    }
  }

  close() {
    this.forgotName = '';
    this.isShowForgotError = false;
    this.fieldSubmitted = false;
    this.noFields = false;
    this.enableInvalidUser = false;
  }

}
